import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=1fc0e990&scoped=true&"
import script from "./AccordionGroup.vue?vue&type=script&lang=js&"
export * from "./AccordionGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&id=1fc0e990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0e990",
  null
  
)

export default component.exports